import './App.css'
import ProtectedRoute from './components/AuthGuard';
import Toast from './components/Toast';
import MainLayout from './layout/MainLayout';

import { Route, Routes } from 'react-router-dom';
import SignIn from './pages/SignIn';
import Cameras from './pages/Cameras';
import AgentsTable from './pages/Agent/AgentTable';
import EventsTable from './pages/Events/EventsTable';
import CredentialConfigPage from './pages/Agent/AgentCredsConfig/CredentialConfigPage';
import Clients from './pages/Clients';
import ClientDetails from './pages/ClientDetails';
import { AuditLogs } from './pages/AuditLogs/AuditLogs';
import AssetsTable from './pages/Assets/AssetsTable';
import ClientMap from './pages/ClientMap';
import Users from './users/Users';
import Roles from './roles/Roles';
import ApiIntegration from './pages/integrations/Integrations';
import ReportsDashboard from './pages/Reports/ReportsDashboard';
import ReportViewer from './pages/Reports/ReportViewer';
import CameraDashboard from './pages/Dashboard/CameraDashboard';
import DistrictOverviewDashboard from './pages/Dashboard/DistrictOverviewDashboard';
import AssetDashboardLayout from './pages/Assets/AssetDetails/AssetDashboardLayout';





function App() {

  return (
    <>
      <Toast />
      <Routes>
        <Route path="/" element={<SignIn />} />

        <Route element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
          <Route path="/dashboard" element={<ProtectedRoute><DistrictOverviewDashboard /></ProtectedRoute>} />
          <Route path="/station-dashboard" element={<ProtectedRoute><CameraDashboard /></ProtectedRoute>} />
          <Route path="/agents" element={<ProtectedRoute><AgentsTable /></ProtectedRoute>} />
          <Route path="/cameras" element={<ProtectedRoute><Cameras /></ProtectedRoute>} />
          <Route path="/events" element={<ProtectedRoute><EventsTable /></ProtectedRoute>} />
          <Route path='/agent-credentials/:agentId' element={<ProtectedRoute><CredentialConfigPage /></ProtectedRoute>} />
          <Route path='/clients' element={<ProtectedRoute><Clients /></ProtectedRoute>} />
          <Route path='/client-details' element={<ProtectedRoute><ClientDetails /></ProtectedRoute>} />
          <Route path='/audit-logs' element={<ProtectedRoute><AuditLogs /></ProtectedRoute>} />
          <Route path='/asset' element={<ProtectedRoute><AssetsTable /></ProtectedRoute>} />
          <Route path='/map' element={<ProtectedRoute><ClientMap /></ProtectedRoute>} />
          <Route path='/users' element={<ProtectedRoute><Users /></ProtectedRoute>} />
          <Route path='/roles' element={<ProtectedRoute><Roles /></ProtectedRoute>} />
          <Route path='/integrations' element={<ProtectedRoute><ApiIntegration /></ProtectedRoute>} />
          <Route path='/reports' element={<ProtectedRoute><ReportsDashboard /></ProtectedRoute>} />
          <Route path='/report/:reportKey' element={<ProtectedRoute><ReportViewer /></ProtectedRoute>} />
          <Route path='/asset/dashboard' element={<ProtectedRoute><AssetDashboardLayout /></ProtectedRoute>} />





        </Route>

      </Routes>
    </>
  )
}

export default App
